import { NgModule } from '@angular/core';
import {
  GlossaryComponent,
  KnowledgeHubComponent,
  ContactUsComponent,
  KnowledgeCardCarouselComponent,
  KnowledgeCardComponent,
  PortfolioManagersComponent,
  VideoComponent,
  KeyFeaturesComponent,
  InfoCircleComponent,
  InvestInfoComponent,
  FlyinBoxComponent,
  CustomChartComponent,
  InfoGraphicCircleComponent,
  KnowledgeHubCoursesComponent,
  CustomTableComponent,
  PresenceMapComponent,
  AnimatedPieChartInBannerComponent,
  InteractiveMapComponent,
  VideoEmbedComponent,
} from '@ft-alts/ui-components/src/lib/marketing-lib';
import { HtmlComponent } from '@ft-alts/ui-components/src/lib/shared-lib';
import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';

@NgModule({
  imports: [],
})
export class MarketingModule implements DynamicModule {
  constructor() {}

  getComponentMapping(): ComponentMapping {
    return {
      'Alts Custom Chart': CustomChartComponent,
      'Alts Knowledge Hub': KnowledgeHubComponent,
      'Alts Glossary': GlossaryComponent,
      'Alts Html Block': HtmlComponent,
      'Alts Contact Us': ContactUsComponent,
      'Alts Knowledge Hub Carousel': KnowledgeCardCarouselComponent,
      'Alts Knowledge Hub Card Grid': KnowledgeCardComponent,
      'Alts Knowledge Hub Courses': KnowledgeHubCoursesComponent,
      'Alts Portfolio Managers': PortfolioManagersComponent,
      'Alts Video': VideoComponent,
      'Alts Key Features': KeyFeaturesComponent,
      'Alts Info Circle': InfoCircleComponent,
      'Alts Invest Info': InvestInfoComponent,
      'Alts Fly In': FlyinBoxComponent,
      'Alts Info Graphic Circle': InfoGraphicCircleComponent,
      'Alts Custom Table': CustomTableComponent,
      'Alts Tabs With Map': PresenceMapComponent,
      'Alts Animated Pie Chart In Banner': AnimatedPieChartInBannerComponent,
      'Alts Interactive Map Tabs': InteractiveMapComponent,
      'Alts Video Embed': VideoEmbedComponent,
    };
  }
}
